import {
  Component,
  Inject,
  OnInit,
  Renderer2,
  PLATFORM_ID
} from "@angular/core";
import { UserService } from "./services/user.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { DataLayerServiceService } from "./data-layer-service.service";
import { CommonService } from "./services/common.service";
import { AppStateService } from "./shared/app-state.service";
import { StateData } from "./shared/common";
import { filter } from "rxjs/operators";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { FontLoaderService } from "./services/FontLoader.service";
import { CssLoaderService } from "./services/css-loader.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  token: any = "";
  isBrowser: boolean;

  constructor(
    private userSrv: UserService,
    private commonService: CommonService,
    private router: Router,
    private _dataLayerService: DataLayerServiceService,
    private activatedRoute: ActivatedRoute,
    private appStateSvc: AppStateService,
    private renderer: Renderer2,
    private fontLoader: FontLoaderService,
    private cssLoader: CssLoaderService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.fontLoader.loadFonts()
          this.cssLoader.loadCss('assets/css/style.css');

    }
    this.getUrlData();

    this.appStateSvc.stateData = new StateData();

    if (this.isBrowser) {
      localStorage.setItem("optionType", "PICKUP");
      localStorage.setItem("isPickUpOrder", "true");
    }

    this.activatedRoute.queryParams.subscribe((res) => {
      this.token = res.token;
      if (this.isBrowser && this.token) {
        localStorage.setItem("token", this.token);
      }
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.isBrowser) {
          this._dataLayerService.logPageView(event.url);

          const existingLink = this.document.querySelector("link[rel='canonical']");
          if (existingLink) {
            this.renderer.removeChild(this.document.head, existingLink);
          }

          if (
            event.urlAfterRedirects === "/" ||
            event.urlAfterRedirects === "/home"
          ) {
            const link: HTMLLinkElement = this.renderer.createElement("link");
            link.setAttribute("rel", "canonical");
            link.setAttribute("href", "https://royalleafs.com/");
            this.renderer.appendChild(this.document.head, link);
          }
        }
      });
  }

  getUrlData() {
    this.commonService.getSiteData();

    if (this.isBrowser) {
      const age = localStorage.getItem("ageVerify");
      const localStoreId = localStorage.getItem("localStoreId");

      if (!localStoreId && age == undefined && window.location.href === 'https://royalleafs.com/') {
        this.router.navigateByUrl("verify/age");
      }
    }
  }

  ngOnInit() {
    if (this.isBrowser) {
      const allReadyLoggedIn = localStorage.getItem("covaUserId");
      if (allReadyLoggedIn) {
        const user = this.getLocalStorage();
        this.afterLogin(user);
      }
    }
  }

  getLocalStorage() {
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const mobileVerified = localStorage.getItem("mobileVerified");
    const documentVerify = localStorage.getItem("documentVerify");

    const user = {
      userId,
      userName,
      mobileVerified,
      documentVerify,
    };
    return user;
  }

  afterLogin(user) {
    this.userSrv.updateUserAuth(true, user);
  }
}
